/**
 * Nap doi tuong trang mot cach lazy, co huy.
 *
 * Trang chi duoc nap khi that su lot vao vung nhin (ke ca vung dem). Nap truoc
 * ca tai lieu la cach nhanh nhat de mot file 800 trang lam sap tab trinh duyet.
 */
import { useEffect, useState } from 'react';
import type { DocumentId, PdfCore, TextBlock } from '@pdfeditor/types';
import { asPageSource } from '../core';
import type { PDFPageProxy } from '../core/pdfjs';

export function usePageProxy(
  core: PdfCore | null,
  doc: DocumentId | null,
  pageIndex: number,
  active: boolean,
): PDFPageProxy | null {
  const [page, setPage] = useState<PDFPageProxy | null>(null);

  useEffect(() => {
    if (!core || !doc || !active) {
      setPage(null);
      return;
    }
    const source = asPageSource(core);
    if (!source) {
      // Loi WASM khong cho muon doi tuong trang cua pdf.js. Khi den luc do,
      // CanvasLayer se chuyen sang dung core.renderPage() va tra ve ImageData.
      setPage(null);
      return;
    }
    let cancelled = false;
    void source
      .getPageProxy(doc, pageIndex)
      .then((p) => {
        if (!cancelled) setPage(p);
      })
      .catch(() => {
        if (!cancelled) setPage(null);
      });
    return () => {
      cancelled = true;
    };
  }, [core, doc, pageIndex, active]);

  return page;
}

/**
 * Nap khoi van ban cua mot trang. Chi chay khi trang dung yen trong vung nhin -
 * trich xuat van ban phai chay het content stream nen dat hon ket xuat nhieu.
 */
export function usePageTextBlocks(
  core: PdfCore | null,
  doc: DocumentId | null,
  pageIndex: number,
  active: boolean,
  onLoaded?: (pageIndex: number, blocks: TextBlock[]) => void,
): TextBlock[] {
  const [blocks, setBlocks] = useState<TextBlock[]>([]);

  useEffect(() => {
    if (!core || !doc || !active) return;
    let cancelled = false;
    void core
      .textBlocks(doc, pageIndex)
      .then((result) => {
        if (cancelled || !result.ok) return;
        setBlocks(result.value);
        onLoaded?.(pageIndex, result.value);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
    // onLoaded co chu y bi bo khoi danh sach phu thuoc: no la ham on dinh o
    // phia goi, dua vao day se tao vong nap lai vo tan.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [core, doc, pageIndex, active]);

  return blocks;
}
